import * as React from 'react';
import {Links} from './Links';
import AFMCSeal from './AFMCSeal';
import KartraSignupForm from './KartraSignupForm';

const Footer = () => (
    <footer className="page-footer green lighten-1">
        <div className="container">
            <div className="row">
                <div className="col l8 s12">
                    <h5 className="white-text">Jodi Franklin, Functional Medicine Practitioners</h5>
                    <p className="grey-text text-lighten-4">
                        Put your chronic, debilitating disease into remission without using drugs.
                    </p>
                    <KartraSignupForm />
                    <p className="grey-text text-lighten-4">
                        The statements made on this website have not been evaluated by the Food and Drug Administration.
                        Our products are not intended to diagnose, treat, cure, or prevent any disease or medical
                        condition.
                    </p>
                </div>
                <div className="col l4 s12">
                    <h5 className="white-text">Site Map</h5>
                    <ul>
                        <Links light footer />
                    </ul>
                    <AFMCSeal id="franklin-jodi" />
                </div>
            </div>
        </div>
        <div className="footer-copyright">
            <div className="container">
                &copy; Jodi Franklin {new Date().getFullYear().toString()}
                <div className="right">
                    <a className="white-text" href="/assets/Privacy_Policy.pdf" target="_blank">
                        Privacy Policy
                    </a>{' '}
                    |{' '}
                    <a className="white-text" href="/assets/Terms_and_Conditions.pdf" target="_blank">
                        Terms and Conditions
                    </a>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
